export default {
  ja:[
    "メーカー",
    "キャラクター",
    "作品名",
    "商品カテゴリー",
    "値段",
    "チップ",
    "円",
    "配送料",
    "着払い",
    "配送料込み",
    "状態",

    "メッセージ",
    "リクエストしたユーザー",
    "住んでいる国",
    "このリクエストは完了しました",
    "アイデアを送った人",
    "ζ*'ヮ')ζ＜ 配送されるのを待ってね―！",
    "注意！",
    "配送しましたか？",
    "あなたのアイデア",
    "ζ*'ヮ')ζ＜ 配送料を含んだ値段で送ってね！",

    "ζ*'ヮ')ζ＜ 着払いなので配送料は含まれていないよ！",
    "状態を選択してね",
    "中古でも良い",
    "新品のみ希望",
    "購入確認",
    "Stripe手数料(3.6%) 円",
    "合計額",
    "送り先住所",
    "住所が登録されていないよ！住所を登録してね！",
    "住所を登録",

    "アイデアを決定したらもうキャンセル出来ないよ！本当にこれで大丈夫？",
    "評価をしてね！",
    "評価",
    "メッセージが送れるよ、お礼を伝えよう！",
    "Stripeの手数料を差し引いた口座に振り込まれる金額",
    "Stripeの手数料を含めた支払い総額",
    "新品",
    "中古",
    "購入",
    "相手に伝える事があったらココに書いてください",

    "閉じる",
    "アイデアを送る",
    "これに決定する",
    "住所の変更",
    "配送完了",
    "送信",
    "ユーザー登録してリクエストしてみる",
    "ユーザー登録してリクエストに応える",
  ],
  en: [
    "Maker",
    "Character",
    "Content title",
    "Category",
    "Price",
    "Tip",
    "JPY",
    "Delivery fee",
    "Cash on delivery",
    "Include shipping fee",
    "State",

    "Message",
    "Request user",
    "Country",
    "This request is completed!",
    "Proposer",
    "ζ*'ヮ')ζ＜ Please wait for the item to be shipped!",
    "Caution!",
    "Please proceed only if you've shipped the item!",
    "Your idea",
    "ζ*'ヮ')ζ＜ Shipping fee included to price!",

    "ζ*'ヮ')ζ＜ Shipping fee will not be included due to Cash on Delivery.",
    "Select state of item",
    "Used ok",
    "New only",
    "Purchase confirmation",
    "+ Stripe fee(3.6%) JPY",
    "Total",
    "Shipping address",
    "You haven't registered your address yet...In order to proceed you'll need to register.",
    "Register address",

    "Heads up! After accepting, you won't be able to cancel. Are you sure?",
    "Please Evaluate",
    "Evaluation",
    "Time to send a message and tell your appreciation!",
    "Deducted Stripe fees amount transferred to your account",
    "Total payment including Stripe fees",
    "New",
    "Used",
    "Purchase",
    "Got any notes? Jot them down!" ,

    "cancel",
    "Suggest an idea",
    "Accept",
    "edit address",
    "Shipped",
    "Send",
    "Register as a user and make a request",
    "Register as a user and respond to requests",
  ]
}
